<template>
    <div id="multi-select">
        <h3 class="ui header">Please choose all that apply:</h3>
        <div class="options">
            <div class="ui checkbox mscheckbox" :ref="'opt'+index" v-for="(option, index) in boosterData.options" v-bind:key="option">
                <input type="checkbox" :disabled="answerMade"/><label></label>
                <div class="label" v-html="option"></div>
            </div>
        </div>
        <button id="checkAnswerButton" class="ui button blue" @click="checkAnswers" v-if="selectedOption == 0 && !answerMade">Check My Answers</button>
        <FeedbackBox  v-if="answerMade" v-bind:message="answerFeedback" v-bind:correct="correct" v-bind:incorrect="incorrect" />
        
    </div>
</template>
<script>
import FeedbackBox from '../FeedbackBox.vue'
export default {
    name: 'MultiSelect',
    props: ['boosterData', 'selectedOption', 'leaderboards', 'api', 'boosterId', 'programId', 'learnerId'],
    components: {
        FeedbackBox
    },
    data() {
        return {
            correct: false,
            incorrect: false,
            answerMade: false,
            answerFeedback: '',
            pointsEarned: 0,
            submission: ''
        }
    },

    mounted() {
        if (this.selectedOption > 0) {
            let wrap = this.$refs['opt'+String(this.selectedOption -1)][0]
            let checkBox = wrap.getElementsByTagName('input')[0];
            checkBox.checked = true;

            this.$nextTick(function() {
                this.checkAnswers()

                
            })
            
        }
    },
    methods: {
        checkAnswers: function(){ 
            if (!this.answerMade) {
                this.answerMade = true;
                let checkedAnswers = []

                let numCorrectSelected = 0
                let numIncorrectSelected = 0

                
                

                for(let a = 0; a < this.boosterData.options.length; a++) {
                    let wrap = this.$refs['opt'+String(a)][0]
                    let box = wrap.getElementsByTagName('input')[0]
                    if (box.checked) {
                        checkedAnswers.push(a + 1)
                        if (this.boosterData.correctAnswers.indexOf(a + 1) > -1) {
                            numCorrectSelected += 1
                            let label = wrap.getElementsByClassName('label')[0]
                            label.classList.add('correct')
                        }
                        else {
                            numIncorrectSelected += 1
                            let label = wrap.getElementsByClassName('label')[0]
                            label.classList.add('incorrect')
                        }
                    }
                    
                }

                for (let a = 0; a < checkedAnswers.length; a++) {
                    this.submission += checkedAnswers[a] + ','
                }

                if (this.boosterData.allowPartiallyCorrect) {
                    if (numCorrectSelected == this.boosterData.correctAnswers.length && numIncorrectSelected == 0) {
                        this.correct = true
                        this.answerFeedback = this.boosterData.correctFeedback
                        
                    }
                    else if(numCorrectSelected == this.boosterData.correctAnswers.length && numIncorrectSelected > 0) {
                        this.answerFeedback = this.boosterData.partiallyCorrectFeedback
                    }
                    else if(numCorrectSelected > 0 && numCorrectSelected < this.boosterData.correctAnswers.length) {
                        this.answerFeedback = this.boosterData.partiallyCorrectFeedback
                    }
                    else if(numCorrectSelected == 0) {
                        this.incorrect = true
                        this.answerFeedback = this.boosterData.incorrectFeedback
                    }
                }
                else {
                    if (numIncorrectSelected > 0) {
                        this.incorrect = true
                        this.answerFeedback = this.boosterData.incorrectFeedback
                    }
                    else {
                        if (numCorrectSelected == this.boosterData.correctAnswers.length) {
                            this.correct = true
                            this.answerFeedback = this.boosterData.correctFeedback
                        }
                        else {
                            this.incorrect = true
                            this.answerFeedback = this.boosterData.incorrectFeedback
                        }
                    }
                }

                if (this.leaderboards) {
                    if (this.boosterData.allowPartiallyCorrect) {
                        let earned = numCorrectSelected - numIncorrectSelected
                        if (earned < 0) earned = 0
                        this.pointsEarned = earned
                        this.$bubble('earnedPoints', earned)
                    }
                    else {
                        if (numIncorrectSelected == 0 && numCorrectSelected == this.boosterData.correctAnswers.length) {
                            this.pointsEarned = 5;
                            this.$bubble('earnedPoints', 5)
                        }
                    }
                }

                if (this.api) {
                    this.api.post('/api/event', {
                        code: 305,
                        lid: this.learnerId,
                        pid: this.programId,
                        bid: this.boosterId,
                        submission: this.submission,
                        correct: this.correct
                    })
                }
            }
        }
    }
}
</script>
<style scoped>

.ui.checkbox {
    display: block;
    margin: 0px 15px 15px 0px;
}

.ui.checkbox .label {
    margin-left: 30px;
}

.label.correct {
    color: #64b548;
}

.label.incorrect {
    color: #d9534f;
}

@media (max-width:640px) {
    .mscheckbox {
        margin-bottom: 30px !important;
    }
}

</style>